/* Klaviyo signup: when a visitor submits any of the theme's email signup forms, the email is also subscribed to the
   Klaviyo list set in Theme settings > Klaviyo signup. The form itself is NOT held back or changed: it goes to Shopify
   straight away (including Shopify's CAPTCHA check), and the Klaviyo request is sent alongside it with keepalive, so it
   finishes even while the page is changing. */
(function () {
  var cfg = window.avalonKlaviyo;
  if (!cfg || !cfg.companyId || !cfg.listId) return;
  var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var type = form.querySelector('input[name="form_type"]');
    if (!type || type.value !== 'customer') return;
    var email = form.querySelector('input[name="contact[email]"]');
    if (!email || !email.value) return;
    if (form.checkValidity && !form.checkValidity()) return;
    // the same form can fire "submit" twice (for example when the CAPTCHA re-sends it): send to Klaviyo only once
    var now = Date.now();
    if (form.avalonKlaviyoAt && now - form.avalonKlaviyoAt < 15000) return;
    form.avalonKlaviyoAt = now;

    var ctx = form.querySelector('input[name="contact[context]"]');
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Website signup' + (ctx && ctx.value ? ' (' + ctx.value + ')' : ''),
          profile: { data: { type: 'profile', attributes: { email: email.value.trim() } } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
    try {
      fetch(url, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify(body)
      }).catch(function () {});
    } catch (err) { /* never block the signup */ }
  }, true);
})();
